import Component from '@galactic-advisors/component-loader';
import { Toast, ToastStatusTypes } from '../../../../ts/toast.ts';

const DEFAULTS = {
  screenshotBtn: '[data-screenshot-btn]',
  takePictureBtn: '[data-take-picture-btn]',
  imagePreviewElement: '[data-image-preview]',
  imageFileNameInput: '[data-image-file-name-input]',
  imageFileInput: '[data-image-file-input]',
  currentFileLabel: '[data-current-file-label]',
  uploadImageFileBtnElement: '[data-upload-img-file-btn]',
  pasteImgBtnElement: '[data-paste-img-btn]',
};

export default class UploadFile extends Component {
  static selector = '[data-comp-upload-file]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.screenshotBtn = this.$container.querySelector(
      this.$options.screenshotBtn
    );

    this.takePictureBtn = this.$container.querySelector(
      this.$options.takePictureBtn
    );

    this.uploadImageFileBtn = this.$container.querySelector(
      this.$options.uploadImageFileBtnElement
    );

    this.pasteImgBtn = this.$container.querySelector(
      this.$options.pasteImgBtnElement
    );

    this.imagePreviewElement = this.$container.querySelector(
      this.$options.imagePreviewElement
    );

    this.imageFileInput = this.$container.querySelector(
      this.$options.imageFileInput
    );

    this.currentFileLabel = this.$container.querySelector(
      this.$options.currentFileLabel
    );

    this.imageFileNameInput = this.$container.querySelector(
      this.$options.imageFileNameInput
    );

    this.toast = Toast.instance;

    this.isUserUsingMobile = () => {
      // User agent string method
      let isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        );

      // Screen resolution method
      if (!isMobile) {
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;
        isMobile = screenWidth < 768 || screenHeight < 768;
      }

      // Touch events method
      if (!isMobile) {
        isMobile =
          'ontouchstart' in window ||
          navigator.maxTouchPoints > 0 ||
          navigator.msMaxTouchPoints > 0;
      }

      // CSS media queries method
      if (!isMobile) {
        const bodyElement = document.getElementsByTagName('body')[0];
        isMobile =
          window
            .getComputedStyle(bodyElement)
            .getPropertyValue('content')
            .indexOf('mobile') !== -1;
      }

      return isMobile;
    };

    this.initListeners();
  }

  async takeScreenshot() {
    const vid = document.createElement('video');

    vid.autoplay = true;

    try {
      const displayMedia = await navigator.mediaDevices.getDisplayMedia();

      vid.srcObject = displayMedia;

      const settings = displayMedia.getTracks()[0].getSettings();

      let { width, height } = settings;

      if (width === 0 || height === 0) {
        width = 1920;
        height = 1080;
      }

      vid.addEventListener('canplay', () => {
        const canvas = document.createElement('canvas');
        vid.width = width;
        vid.height = height;
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(vid, 0, 0);
        const dateStr = new Date().toUTCString();
        ctx.fillStyle = 'white';
        ctx.font = '20px sans-serif';
        ctx.textAlign = 'right';
        ctx.textBaseline = 'top';
        ctx.shadowOffsetX = 2;
        ctx.shadowOffsetY = 2;
        ctx.shadowColor = 'black';
        ctx.fillText(dateStr, vid.width, 0);
        vid.srcObject?.getTracks().forEach((track) => track.stop());
        vid.srcObject = null;

        canvas.toBlob((blob) => {
          this.imagePreviewElement.src = URL.createObjectURL(blob);
          this.imagePreviewElement.classList.add('border', 'rounded');
          const file = new File([blob], `${new Date().toDateString()}.png`);
          this.imageFileNameInput.value = file.name;
          const container = new DataTransfer();
          container.items.add(file);
          this.imageFileInput.files = container.files;
        });
      });
    } catch (error) {
      console.error(error);
      const stream = vid.srcObject;
      if (!stream) {
        console.error(
          'Please allow use of the screenshot tool in your browser settings and try again.'
        );
      } else {
        stream.getTracks().forEach((track) => track.stop());
        vid.srcObject = null;
        console.error(error);
      }
    }
  }

  setImagePreview(file) {
    this.imagePreviewElement.src = URL.createObjectURL(file);
    this.imagePreviewElement.classList.add('border', 'rounded');
    this.currentFileLabel.innerText = file.name;
  }

  saveFile() {
    this.imageFileInput.click();
    this.imageFileInput.onchange = () => {
      const [file] = this.imageFileInput.files;
      if (file && this.imageFileInput.accept.includes(file.type)) {
        this.imageFileNameInput.value = file.name;
        if (file.type.startsWith('image/')) {
          this.setImagePreview(file);
        }
      } else {
        this.toast.show(
          ToastStatusTypes.DANGER,
          'This file type is not supported. Supported files: jpeg, png, gif, doc, docx, msword, or pdf'
        );
      }
    };
  }

  initListeners() {
    document.addEventListener('paste', async (e) => {
      e.preventDefault();
      if (!e.clipboardData.files.length) {
        this.toast.show(
          ToastStatusTypes.DANGER,
          'No accepted files exist within your clipboard!'
        );
        return;
      }

      const file = e.clipboardData.files[0];

      if (file.type.startsWith('image/')) {
        this.setImagePreview(file);

        this.imageFileNameInput.value = file.name;
        const container = new DataTransfer();
        container.items.add(file);
        this.imageFileInput.files = container.files;
      } else {
        this.toast.show(
          ToastStatusTypes.DANGER,
          'No accepted files exist within your clipboard!'
        );
      }
    });

    this.screenshotBtn &&
      this.screenshotBtn.addEventListener('click', async (event) => {
        event.preventDefault();
        await this.takeScreenshot();
      });

    this.takePictureBtn &&
      this.takePictureBtn.addEventListener('click', (event) => {
        event.preventDefault();
        return this.saveFile();
      });
  }
}
